"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoPoverty = void 0;
var React = __importStar(require("react"));
var NoPoverty = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 554.2 604"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
    transform: "translate(82.000000, 69.129166)"
  }, React.createElement("path", {
    fill: "#E1081F",
    d: "M404.4,216.3c0-11.1,9-20.1,20.1-20.1s20.1,9,20.1,20.1s-9,20.1-20.1,20.1\n          C413.4,236.4,404.4,227.4,404.4,216.3"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M447.9,244.2c13.6,1.2,24.3,12.7,24.3,26.7v6.7v2.9v46.1c0,4.3-3.5,7.8-7.8,7.8\n          s-7.8-3.5-7.8-7.8v-47.9c0-1.8-0.5-4.2-3.8-4.2c-2.3,0-2.7,2.4-2.8,3.9v143.5c0,6.2-5,11.2-11.2,11.2s-11.2-5-11.2-11.2v-82.7\n          c0-0.9-0.3-3.3-3.2-3.3l0,0c-2.9,0-3.2,2.4-3.2,3.3v82.7c0,6.2-5,11.2-11.2,11.2s-11.2-5-11.2-11.2V278.5\n          c-0.1-1.5-0.6-3.9-2.8-3.9c-3.3,0-3.8,2.4-3.8,4.2v47.8c0,4.3-3.5,7.8-7.8,7.8s-7.8-3.5-7.8-7.8v-46.1v-2.9v-6.7\n          c0-14,10.7-25.5,24.3-26.7c0.4-0.1,0.9-0.1,1.5-0.1h22h21.9C447,244.1,447.4,244.1,447.9,244.2"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M285,226.9c0-10.5-8.5-19.1-19-19.1s-19,8.5-19,19.1c0,10.5,8.5,19,19,19\n          S285,237.4,285,226.9"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M227.6,270l-15.8,51.6c0,0-2.8,9.4,5.2,11.8s10.4-6.9,10.4-6.9l12.7-43c0,0,0.7-3.3,3.2-2.6\n          c2.5,0.7,1.6,4.3,1.6,4.3l-22.2,80.6h20.6v57.7c0,5.5,4.4,9.9,9.9,9.9c5.5,0,9.9-4.4,9.9-9.9v-57.7h2.8h2.8v57.7\n          c0,5.5,4.4,9.9,9.9,9.9s9.9-4.4,9.9-9.9v-57.7h20.6l-22.2-80.6c0,0-0.9-3.5,1.5-4.3c2.5-0.7,3.2,2.6,3.2,2.6l12.7,43\n          c0,0,2.4,9.2,10.4,6.9c8-2.4,5.2-11.8,5.2-11.8L304.3,270c0,0-5.6-14.9-18.2-14.9H266h-20.2C233.3,255.1,227.6,270,227.6,270"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M171,226.9c0-10.5-8.5-19.1-19-19.1s-19,8.5-19,19.1c0,10.5,8.5,19,19,19\n          S171,237.4,171,226.9"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M113.7,270l-15.8,51.6c0,0-2.8,9.4,5.2,11.8s10.4-6.9,10.4-6.9l12.8-43\n          c0,0,0.7-3.3,3.2-2.6c2.5,0.7,1.6,4.3,1.6,4.3l-22.2,80.6h20.6v57.7c0,5.5,4.5,9.9,9.9,9.9c5.5,0,9.9-4.4,9.9-9.9v-57.7h2.8h2.8\n          v57.7c0,5.5,4.4,9.9,9.9,9.9s9.9-4.4,9.9-9.9v-57.7h20.6l-22.2-80.6c0,0-0.9-3.5,1.5-4.3c2.5-0.7,3.2,2.6,3.2,2.6l12.7,43\n          c0,0,2.4,9.2,10.4,6.9c8-2.4,5.2-11.8,5.2-11.8L190.3,270c0,0-5.6-14.9-18.2-14.9H152h-20.2C119.4,255.1,113.7,270,113.7,270"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M348.8,333.5c8.8,0,15.8-7.1,15.8-15.9s-7.1-15.8-15.8-15.8c-8.8,0-15.8,7.1-15.8,15.8\n          C333,326.4,340.1,333.5,348.8,333.5"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M310.9,382.7c-0.8,1.9-1.4,5.8,2.3,7.5c4.4,2,6.8-2.2,6.8-2.2l8.6-27.5\n          c0,0,1.5-1.8,1.5,0.1v64.7l0,0c0,4.5,3.6,8.1,8.1,8.1s8.1-3.6,8.1-8.1v-25.5c0,0-0.5-3.6,2.4-3.6s2.5,3.6,2.5,3.6v25.5\n          c0,4.5,3.6,8.1,8.1,8.1s8.1-3.6,8.1-8.1v-64.7c0-1.9,1-0.5,1-0.5l6.7,18.8c0,0,2.9,8.4,3.8,8.8c3,1.3,6.6-0.2,7.8-3.2\n          c0.8-2,0.5-4.2-0.6-5.8l0.1-0.1c-0.2-0.6-10.1-24.9-11.2-28.3c-3.6-10.4-10.1-10.3-16.3-10.5c-6.3-0.1-10,0-10,0\n          s-4-0.2-12.3,0.1c-8.2,0.3-10.9,4.5-20,27.9C315.3,371.1,310.9,382,310.9,382.7L310.9,382.7z"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M1.2,216.3c0-11.1-9-20.1-20.1-20.1s-20.1,9-20.1,20.1s9,20.1,20.1,20.1\n          C-7.8,236.4,1.2,227.4,1.2,216.3"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M-42.4,244.2c-13.6,1.2-24.3,12.7-24.3,26.7v6.7v2.9v46.1c0,4.3,3.5,7.8,7.8,7.8\n          s7.8-3.5,7.8-7.8v-47.9c0-1.8,0.5-4.2,3.8-4.2c2.3,0,2.7,2.4,2.8,3.9v143.5c0,6.2,5,11.2,11.2,11.2s11.2-5,11.2-11.2v-82.7\n          c0-0.9,0.3-3.3,3.2-3.3l0,0c2.9,0,3.2,2.4,3.2,3.3v82.7c0,6.2,5,11.2,11.2,11.2s11.2-5,11.2-11.2V278.5c0.1-1.5,0.6-3.9,2.8-3.9\n          c3.3,0,3.8,2.4,3.8,4.2v47.8c0,4.3,3.5,7.8,7.8,7.8s7.8-3.5,7.8-7.8v-46.1v-2.9v-6.7c0-14-10.7-25.5-24.3-26.7\n          c-0.5-0.1-0.9-0.1-1.5-0.1h-22h-21.9C-41.4,244.1-41.9,244.1-42.4,244.2"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M-64.1,334l-17.8,94.6c-0.4,2.3,1.1,4.6,3.4,5s4.6-1.1,5-3.4l17.8-94.7\n          c0.4-2.3-1.1-4.6-3.4-5S-63.6,331.6-64.1,334z"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M38.4,325.2c-1-1.6-2.8-2.7-4.9-2.7c-3.2,0-5.8,2.6-5.8,5.8c0,0.9,0.6,2.5,0.6,2.5l16,28.9\n          c0,0,1,2,1,3.8v62.1l0,0c0,4.3,3.5,7.8,7.8,7.8s7.8-3.5,7.8-7.8v-24.5c0,0-0.4-3.5,2.4-3.5s2.4,3.5,2.4,3.5v24.5\n          c0,4.3,3.5,7.8,7.8,7.8s7.8-3.5,7.8-7.8v-62.1c0-1.8,1-3.8,1-3.8L97.1,333c0,0,1.8-3.8,1.8-4.8c0-3.2-2.6-5.8-5.8-5.8\n          c-2.1,0-3.9,1.1-4.9,2.7h-0.1c-0.5,0.4-7.8,13.6-10.3,16c-2.6,2.6-4.9,2.3-4.9,2.3h-9.6h-9.6c0,0-2.3,0.3-4.9-2.3\n          C46.3,338.7,38.9,325.5,38.4,325.2L38.4,325.2z"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M63.2,333.5c8.8,0,15.8-7.1,15.8-15.9s-7.1-15.8-15.8-15.8c-8.8,0-15.8,7.1-15.8,15.8\n          C47.4,326.4,54.5,333.5,63.2,333.5"
  }), React.createElement("polygon", {
    fill: "#E1081F",
    points: "63.3,355.7 81.1,368.8 89.6,400.1 63.3,400.1 36.8,400.1 45.4,368.8"
  }), React.createElement("polygon", {
    fill: "#E1081F",
    points: "-53,-34.7 -52.8,-34.7 -52.8,77.4 -28.2,77.4 -28.2,-69.1 -47.9,-69.1 \n          -70.5,-42.5 -70.5,-16.8 -70.3,-16.8"
  }), React.createElement("polygon", {
    fill: "#E1081F",
    points: "61.9,-44.9 61.9,-6.5 53.2,-6.5 53.2,-67.7 63.3,-67.7 74.4,-32.6 74.4,-67.7 \n          83,-67.7 83,-6.5 74,-6.5"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M109.7-20.7v-32.8c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3v32.9\n          c0,3.7,1.6,6.3,5.2,6.3C108-14.3,109.7-17,109.7-20.7 M88.8-22.3v-29.6c0-9.6,4.7-16.5,15.5-16.5c10.9,0,15.6,7,15.6,16.5v29.6\n          c0,9.5-4.7,16.5-15.6,16.5C93.5-5.8,88.8-12.8,88.8-22.3"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M63.5,26.5v24.1h3.8c3.5,0,5.1-1.7,5.1-5.1V31.4c0-3.3-1.5-5-5.1-5L63.5,26.5L63.5,26.5z\n            M53.2,18.1h15.2c10.4,0,14.2,5.1,14.2,13.7v12.9c0,8.6-3.8,13.8-14.2,13.8h-5v20.8H53.1V18.1H53.2z"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M108.8,65.1V32.2c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3v32.9\n          c0,3.7,1.6,6.3,5.2,6.3C107.1,71.4,108.8,68.8,108.8,65.1 M87.9,63.5V33.9c0-9.6,4.7-16.5,15.5-16.5c10.9,0,15.6,7,15.6,16.5\n          v29.6c0,9.5-4.7,16.5-15.6,16.5C92.6,80,87.9,73,87.9,63.5"
  }), React.createElement("polygon", {
    fill: "#E1081F",
    points: "156,18.1 144.4,79.3 133.2,79.3 121.6,18.1 132,18.1 139.1,60.8 139.2,60.8 \n          146.4,18.1"
  }), React.createElement("polygon", {
    fill: "#E1081F",
    points: "160.2,18.1 184.8,18.1 184.8,26.5 170.5,26.5 170.5,44 180.7,44 180.7,52.3 \n          170.5,52.3 170.5,70.9 184.8,70.9 184.8,79.3 160.2,79.3"
  }), React.createElement("path", {
    fill: "#E1081F",
    d: "M200.6,26.5v19.1h3.4c3.5,0,5.1-1.8,5.1-5.1v-9c0-3.3-1.5-5-5.1-5H200.6z M200.6,51.2v28.1\n          h-10.3V18.1h15c10.4,0,14.2,5.1,14.2,13.7v7.9c0,6.6-2.3,10.5-8.2,11.8l9.8,27.8h-10.8L200.6,51.2z"
  }), React.createElement("polygon", {
    fill: "#E1081F",
    points: "222.9,18.1 250.2,18.1 250.2,26.5 241.8,26.5 241.8,79.3 231.4,79.3 231.4,26.5 \n          222.9,26.5"
  }), React.createElement("polygon", {
    fill: "#E1081F",
    points: "275,56 275,79.3 264.7,79.3 264.7,56 253.3,18.1 264,18.1 270.2,41.3 270.3,41.3 \n          276.6,18.1 286.4,18.1"
  }))))));
};
exports.NoPoverty = NoPoverty;